import { useState, useEffect } from 'react';
import {
  collection,
  query,
  where,
  getDocs,
  getFirestore
} from 'firebase/firestore';
import firebaseApp from '../../../firebase/credenciales';
import Swal from 'sweetalert2';

const db = getFirestore(firebaseApp);

/**
 * Hook personalizado para manejar el estado y operaciones de planillas
 * @param {Object} usuario - Datos del usuario actual
 * @returns {Object} - Estado y funciones para manejar planillas
 */
export const usePlanillas = (usuario) => {
  const [planillas, setPlanillas] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);

  // Cargar planillas desde Firestore
  const cargarPlanillas = async () => {
    try {
      setLoading(true);
      setError(null);

      if (!usuario?.ruc) {
        throw new Error("Usuario no tiene RUC configurado");
      }

      const q = query(
        collection(db, "pl_planillas"),
        where("ruc_empresa", "==", usuario.ruc)
      );

      const querySnapshot = await getDocs(q);
      const planillasData = [];

      querySnapshot.forEach((doc) => {
        const data = doc.data();

        if (!data.periodo || !data.estado) {
          console.warn("Planilla con datos incompletos:", doc.id, data);
          return;
        }

        planillasData.push({
          id: doc.id,
          ...data,
          total_empleados: data.total_empleados || 0,
          total_neto: data.total_neto || 0,
          estado: data.estado?.toUpperCase() || "BORRADOR"
        });
      });

      const planillasOrdenadas = planillasData.sort((a, b) => {
        try {
          return b.periodo.localeCompare(a.periodo);
        } catch (error) {
          console.warn("Error al ordenar planillas:", error);
          return 0;
        }
      });

      setPlanillas(planillasOrdenadas);
      console.log(`✅ ${planillasOrdenadas.length} planillas cargadas exitosamente`);

    } catch (error) {
      console.error("❌ Error al cargar planillas:", error);
      setError(error);

      let mensajeError = "No se pudieron cargar las planillas";
      if (error.message?.includes('permission-denied')) {
        mensajeError = "No tiene permisos para acceder a las planillas";
      }

      Swal.fire({
        icon: "error",
        title: "Error al Cargar Planillas",
        html: `<div style="text-align: left;">
          <strong>${mensajeError}</strong><br>
          <small style="color: #666;">Detalles: ${error.message}</small>
        </div>`,
        confirmButtonText: "Reintentar",
        showCancelButton: true,
        cancelButtonText: "Cancelar"
      }).then((result) => {
        if (result.isConfirmed) {
          cargarPlanillas();
        }
      });

      setPlanillas([]);
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    cargarPlanillas();
  }, []);

  return {
    planillas,
    loading,
    error,
    recargarPlanillas: cargarPlanillas
  };
};